// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__af2om","content":"ManualTimeModal_content__1C6BH"};